"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "felt", {
    enumerable: true,
    get: function() {
        return felt;
    }
});
var _sjekker = require("./sjekker");
var _feltindikator = require("./feltindikator");
var _valideringsregler = /*#__PURE__*/ _interop_require_wildcard(require("../validering/valideringsregler"));
var _felttyper = require("./felttyper");
var _opsjoner = require("./opsjoner");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
var felt = {
    feltErDropdown: _sjekker.feltErDropdown,
    feltErRadio: _sjekker.feltErRadio,
    feltErAvkrysningsboks: _sjekker.feltErAvkrysningsboks,
    feltSkalDeaktiveres: _sjekker.feltSkalDeaktiveres,
    feltSkalAktiveres: _sjekker.feltSkalAktiveres,
    feltSkalSkjules: _sjekker.feltSkalSkjules,
    feltSkalSkjulesIKort: _sjekker.feltSkalSkjulesIKort,
    feltSkalSlettes: _sjekker.feltSkalSlettes,
    feltHarBeholdVerdi: _sjekker.feltHarBeholdVerdi,
    finnFelttype: _felttyper.finnFelttype,
    feltHarAktiverDeaktiverGitt: _sjekker.feltHarAktiverDeaktiverGitt,
    feltHarReferanseTilAktiverDeaktiverGitt: _sjekker.feltHarReferanseTilAktiverDeaktiverGitt,
    finnDefaultVerdi: _sjekker.finnDefaultVerdi,
    foelgerBetingelse: _sjekker.foelgerBetingelse,
    foelgerAlleBetingelser: _sjekker.foelgerAlleBetingelser,
    gyldigeOpsjonerForFelt: _opsjoner.gyldigeOpsjonerForFelt,
    feltindikator: (0, _feltindikator.feltindikator)(_valideringsregler),
    skalEkspandereFeltgruppe: _sjekker.skalEkspandereFeltgruppe,
    erPresentasjonsfelt: _sjekker.erPresentasjonsfelt,
    defaultVerdiForDatoegenskap: _opsjoner.defaultVerdiForDatoegenskap,
    feltgruppeTekstSkalSkjules: _sjekker.feltgruppeTekstSkalSkjules
};
